// extracted by mini-css-extract-plugin
export default {"MagicLinkContainer":"MagicLink_MagicLinkContainer__UBwzB"};